import React from 'react'
import { Link } from "react-router-dom";
const name=sessionStorage.getItem('name');
export default function Topbar() {
  return (
    <>
      <div className="d-flex flex-row-reverse">
      {(name!==null && name!==undefined)?
        <div className="">
          {sessionStorage.getItem('name') }
          &nbsp; &nbsp;
         
          <Link to="/change-password">
          <i className='bx bx-cog icon'></i>

        </Link>
          
         

        </div>
        :""}
      </div>
    </>
  )
}
